import React from 'react';
import { BlogPost } from '../types';

interface BlogCardProps {
  post: BlogPost;
  onOpen: (post: BlogPost) => void;
}

const BlogCard: React.FC<BlogCardProps> = ({ post, onOpen }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onOpen(post);
  };

  return (
    <div className="blog-card" onClick={handleClick}>
      <div className="blog-date">{post.date}</div>
      <h3 className="blog-title">{post.title}</h3>
      <p className="blog-excerpt">{post.excerpt}</p>
      <button className="blog-read-more" onClick={handleClick}>
        Read more →
      </button>
    </div>
  );
};

export default BlogCard;